import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-stats-widget',
  templateUrl: './home-stats-widget.component.html',
  styleUrls: ['./home-stats-widget.component.scss']
})
export class HomeStatsWidgetComponent {
  @Input() value: string = "";
  @Input() icon: string = "";
  @Input() tooltipText: string = "";
}
